module.exports = __webpack_public_path__ + "img/shade.b1faf062.png";